module.exports = __webpack_public_path__ + "img/upload_image.51ac8cbf.svg";